import home from '../components/homeComponents/home.vue';
//import home2 from '../components/homeComponents/home2.vue';
import review from '../components/reviewComponent/review.vue';
import login from '../components/userComponents/login/login.vue';
import loginWithUrl from '../components/userComponents/loginWithUrl/loginWithUrl.vue';
import register from '../components/userComponents/register/register.vue';
import forgetPassword from '../components/userComponents/forgetPassword/forgetPassword.vue';
import notFound from '../components/errorComponents/notFound.vue';
import filter from '../components/filterComponents/filters.vue';
import product from '../components/productComponents/product.vue';
import profile from '../components/profileComponent/profile.vue';
import info from '../components/profileComponent/info.vue';
import colleagueOrder from '../components/profileComponent/colleagueOrder.vue';
import customerReviews from '../components/profileComponent/reviews/customerReviews.vue';
import customerQuestions from '../components/profileComponent/questions/customerQuestions.vue';
import credit from '../components/profileComponent/credit/credit.vue';
import changePassword from '../components/profileComponent/changePassword.vue';
import orders from '../components/profileComponent/orders.vue';
import transactions from '../components/profileComponent/transactions.vue';
import addresses from '../components/profileComponent/address/addresses.vue';
import cart from '../components/cartComponents/cart.vue';
import chooseAddress from '../components/addressComponents/chooseAddress.vue';
import webServiceError from '../components/errorComponents/webServiceError.vue';
import invoice from '../components/invoiceComponent/invoice.vue';
import orderTracking from '../components/orderTrackingComponent/orderTracking.vue'; 
import compareProduct from '../components/compareProductComponent/compareProduct.vue';
import content from '../components/contentComponents/content.vue';
import contactUs from '../components/contactUsComponent/contactUs.vue';
import aboutUs from '../components/contentComponents/aboutUs.vue';
import rules from '../components/contentComponents/rules.vue';
import descriptionBulkPurchases from '../components/contentComponents/descriptionBulkPurchases.vue';
import downloadApp from '../components/contentComponents/downloadApp.vue';
import laptopPriceList from '../components/contentComponents/laptopPriceList.vue';
import mobilePriceList from '../components/contentComponents/mobilePriceList.vue';
import privacy from '../components/contentComponents/privacy.vue';
import colleagueOrders from '../components/colleagueOrdersComponents/colleagueOrders.vue';
import SuccessColleagueOrders from '../components/colleagueOrdersComponents/SuccessColleagueOrders.vue';
export const routes = [

    { path: '/', component: home },
    //{ path: '/home2', component: home2 },
    { path: '/login', component: login },
    { path: '/loginWithUrl', component: loginWithUrl },
    { path: '/register', component: register },
    { path: '/contactUs', component: contactUs },
    { path: '/forgetPassword', component: forgetPassword },
    { name: 'filter', path: '/filter', component: filter },
    { path: '/cart', component: cart },
    { path: '/colleagueOrders', component: colleagueOrders },
    { path: '/SuccessColleagueOrders', component: SuccessColleagueOrders },
    { path: '/invoice', component: invoice },
 
    { name: 'orderTracking' ,  path: '/orderTracking/:hashOrderId', component: orderTracking },
    { path: '/chooseAddress', component: chooseAddress },
    { name: 'product', path: '/product/:productId/:productName', component: product },
    { name: 'review', path: '/review/:productId', component: review },
    { name: 'compareProduct', path: '/compareProduct', component: compareProduct },
    {
        path: '/profile', component: profile,
        children: [
            { name: 'info', path: '/info', component: info },
            { name: 'credit', path: '/credit', component: credit },
            { name: 'orders', path: '/orders', component: orders },
            { name: 'customerReviews', path: '/customerReviews', component: customerReviews },
            { name: 'customerQuestions', path: '/customerQuestions', component: customerQuestions },
            { name: 'transactions', path: '/transactions', component: transactions },
            { name: 'changePassword', path: '/changePassword', component: changePassword },
            { name: 'addresses', path: '/addresses', component: addresses },
            { name: 'colleagueOrder', path: '/colleagueOrder', component: colleagueOrder },
        ]
    },
    {
        name: 'content', path: '/content', component: content,
        children: [
            { name: 'aboutUs', path: '/aboutUs', component: aboutUs },
            { name: 'rules', path: '/rules', component: rules },
            { name: 'privacy', path: '/privacy', component: privacy },
            { name: 'descriptionBulkPurchases', path: '/descriptionBulkPurchases', component: descriptionBulkPurchases },
            { name: 'laptopPriceList', path: '/laptopPriceList', component: laptopPriceList },
            { name: 'mobilePriceList', path: '/mobilePriceList', component: mobilePriceList },
            { name: 'downloadApp', path: '/downloadApp', component: downloadApp },
        ]
    },
    { path: '/webServiceError', component: webServiceError },
    { name: 'content', path: '/content/:pageName', component: content } , 
    { path: '*', component: notFound },
]




